module.exports = __webpack_public_path__ + "media/fonts/Oricons-95407a027a3ca0bed28743665587a047.woff";